<template>
    <transition
        @enter="enter"
        @after-enter="afterEnter"
        @leave="leave"
        @after-leave="afterLeave"
    >
        <slot class="animation-content" v-if="isShow && isLeftLeave" />
    </transition>
</template>

<script>
export default {
    props: {
        isShow: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        enter(el) {
            el.classList.add('animation-enter')
            el.classList.remove('animation-leave')
        },
        leave(el) {
            el.classList.add('animation-leave')
            el.classList.remove('animation-enter')
        },
        afterEnter() {
            this.$store.dispatch('transition/changeRight', false)
            $('#tiles').trigger('resize')
        },
        afterLeave() {
            this.$store.dispatch('transition/changeRight', true)
            $('#tiles').trigger('resize')
        }
    },
    computed: {
        isLeftLeave() { return this.$store.state?.transition?.isLeftLeaved }
    }
}
</script>

<style lang="sass" scoped>
.animation-content
.animation-enter
    animation: enter 0.3s
.animation-leave
    animation: leave 0.3s
@keyframes enter
    from
        transform: translateX(500px)
        opacity: 0
    to
        transform: translateX(0)
        opacity: 1

@keyframes leave
    from
        transform: translateX(0)
        opacity: 1
    to
        transform: translateX(500px)
        opacity: 0
</style>